import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Button } from "../ui/button";
import TagBadge from "./TagBadge";
import { useBlogStore } from "@/zustand/blogStore";
import Loader from "./Loader";
import { BlogPost } from "@/types/blogTypes";

// components/molecules/BlogCard.tsx

export default function BlogCard({ post }: { post: BlogPost }) {

    const [isLoading, setIsLoading] = useState(true);

    const setBlogId = useBlogStore((state) => state.setBlogId);

    return (

        <div
            className=" overflow-hidden  py-mob-50 first:pt-0 last:pb-0 last:border-none sm:py-0 border-b border-black/20 sm:border-none"
            onClick={() => setBlogId(post.id)}
        >
            <div className="relative group">
                <Link href={post.link} className="relative block overflow-hidden rounded-lg">
                    {isLoading && (
                        <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-50/50 pointer-events-none">
                            <Loader />
                        </div>
                    )}
                    <div className={`relative w-full h-[70vw] sm:h-[26.625vw] lg:h-[15.625vw] transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}>
                        <Image
                            src={post.image.blogImage || post.image.mobile}
                            alt={post.image.alt}
                            fill
                            className="object-cover rounded-lg"
                            onLoad={() => setIsLoading(false)}
                            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 33vw, 25vw"
                        />
                    </div>
                </Link>

                <div className="pt-mob-30 sm:pt-tab-30 lg:pt-web-30">
                    <div className="absolute left-mob-20 sm:left-tab-20 top-mob-20 sm:top-tab-20 lg:top-web-20 lg:left-web-30 ">
                        {post.tag && <TagBadge label={post.tag} color="red" />}
                    </div>
                    <div className="flex items-center gap-mob-10  sm:gap-tab-10 lg:gap-web-10">
                        <span className="block lg:text-web-17 text-[#757575] font-medium text-mob-14 sm:text-tab-14">{post.published_at}</span>
                        <span className="leading-none text-[#757575]">·</span>
                        <span className="block lg:text-web-17 text-[#757575] capitalize text-mob-14 sm:text-tab-14">{post.content_type}</span>
                    </div>
                    <Link href={post.link}>
                        <h3 dangerouslySetInnerHTML={{ __html: post.title }} className="text-mob-30 sm:text-tab-30 lg:text-web-30 font-normal leading-[124%] text-TitleBlack group-hover:text-PrimaryLightBlue transition mt-mob-10 sm:mt-tab-10 lg:mt-web-10 line-clamp-2"></h3>
                    </Link>
                    <p className="text-TitleBlack mt-mob-14 sm:mt-tab-10 lg:mt-web-10 text-mob-16 sm:text-tab-14 lg:text-web-20 line-clamp-4 leading-mob-24 sm:leading-tab-24 lg:leading-web-30">
                        {post.excerpt}
                    </p>
                    <Link href={post.link}>
                        <Button variant={"secondaryLinkBtnBlue"} className="ml-0 text-PrimaryLightBlue hover:text-[#44A8EC] !p-0 hover:!bg-transparent mt-mob-20 sm:mt-tab-15 lg:mt-web-20 group">
                            Read More
                            <div className="w-mob-7 sm:w-tab-7 lg:w-web-7 h-auto group-hover:transform group-hover:translate-x-0.5 transition-transform relative">
                                <Image
                                    src="/images/chevron-right-blue.svg"
                                    alt="Blurred Image"
                                    fill
                                    className="!static !h-auto"
                                />
                            </div>
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
